// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-rXp-container .rDNA-rXp-title {
  font-family: "Dm Sans", sans-serif;
  font-size: 18px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-rXp-container .rDNA-rXP-btn {
  font-family: "Dm Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-rXp-container .rDNA-rXp-descrip {
  font-family: "Dm Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
}

.rDNA-rXp-container .rDNA-rXp-box, .rDNA-rXp-container {
  display: flex;
  flex-direction: column;
}

.rDNA-rXp-container {
  justify-content: center;
  align-items: center;
}

.rDNA-rXp-container .rDNA-rXp-box {
  justify-content: flex-end;
  align-items: center;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-rXp-container {
  height: 250px;
  background: #00AC8E;
  border-radius: 30px;
  margin: 0 10px;
}
.rDNA-rXp-container .rDNA-rXp-box {
  flex: 1;
}
.rDNA-rXp-container .rDNA-rXp-box:nth-of-type(1) {
  flex: 1.75;
}
.rDNA-rXp-container .rDNA-rXp-box:nth-of-type(2) {
  justify-content: center;
}
.rDNA-rXp-container .rDNA-rXp-box:last-of-type {
  padding-bottom: 5px;
}
.rDNA-rXp-container .rDNA-rXp-icon {
  margin-top: 10px;
  border-radius: 25%;
}
.rDNA-rXp-container .rDNA-rXp-title {
  color: #fff;
  letter-spacing: 1.5px;
  margin: 10px 0;
}
.rDNA-rXp-container .rDNA-rXp-descrip {
  color: #fff;
  margin: 0;
  width: 200px;
  letter-spacing: 1.1px;
  line-height: 1.1;
  text-align: center;
}
.rDNA-rXp-container .rDNA-rXP-btn {
  background: #fff;
  color: #1B3E78;
  height: 55px;
  width: 50px;
  border-radius: 10px;
}

@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-rXp-container {
    height: 175px;
    margin: 0 3px;
  }
  .rDNA-rXp-container .rDNA-rXp-icon {
    margin-top: 5px;
    height: 40px;
    width: 40px;
  }
  .rDNA-rXp-container .rDNA-rXp-title {
    font-size: 14px;
    margin: 5px 0;
  }
  .rDNA-rXp-container .rDNA-rXp-descrip {
    width: 120px;
    font-size: 10px;
    line-height: 1.3;
    letter-spacing: 1px;
  }
  .rDNA-rXp-container .rDNA-rXP-btn {
    height: 30px;
    width: 80px;
    font-size: 10px;
  }
  .rDNA-rXp-container .rDNA-rXp-box:last-of-type {
    padding-bottom: 10px;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-rXp-container {
    height: 210px;
  }
  .rDNA-rXp-container .rDNA-rXp-icon {
    margin-top: 10px;
    height: 50px;
    width: 50px;
  }
  .rDNA-rXp-container .rDNA-rXp-title {
    font-size: 18px;
    margin: 7px 0 2px;
  }
  .rDNA-rXp-container .rDNA-rXp-descrip {
    width: 135px;
    font-size: 12px;
  }
  .rDNA-rXp-container .rDNA-rXP-btn {
    height: 40px;
    width: 100px;
    font-size: 14px;
  }
  .rDNA-rXp-container .rDNA-rXp-box:last-of-type {
    padding-bottom: 15px;
  }
}
@media screen and (max-width: 2559.7px) and (min-width: 1199.7px) {
  .rDNA-rXp-container {
    height: 325px;
  }
  .rDNA-rXp-container .rDNA-rXp-icon {
    margin-top: 30px;
  }
  .rDNA-rXp-container .rDNA-rXp-title {
    font-size: 28px;
    margin: 10px 0;
  }
  .rDNA-rXp-container .rDNA-rXp-descrip {
    width: 175px;
    font-size: 14px;
    line-height: 1.5;
    letter-spacing: 1.5px;
  }
  .rDNA-rXp-container .rDNA-rXP-btn {
    height: 55px;
    width: 150px;
    font-size: 18px;
  }
  .rDNA-rXp-container .rDNA-rXp-box:last-of-type {
    padding-bottom: 30px;
  }
}
@media screen and (min-width: 2560px) {
  .rDNA-rXp-container {
    height: 450px;
  }
  .rDNA-rXp-container .rDNA-rXp-icon {
    margin-top: 50px;
  }
  .rDNA-rXp-container .rDNA-rXP-btn {
    width: 200px;
  }
  .rDNA-rXp-container .rDNA-rXp-title {
    font-size: 32px;
    margin: 20px 0;
  }
  .rDNA-rXp-container .rDNA-rXp-icon {
    margin-top: 5px;
    height: 100px;
    width: 100px;
  }
  .rDNA-rXp-container .rDNA-rXp-descrip {
    width: 250px;
    line-height: 1.5;
    letter-spacing: 1.5px;
    font-size: 24px;
  }
  .rDNA-rXp-container .rDNA-rXP-btn {
    height: 65px;
    width: 250px;
    font-size: 24px;
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/shared/toolbox/retail-x-pro/retail-x-pro.component.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_flexboxes.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;ACYA;ECHE,kCFXY;EEYZ,eDE2C;ECD3C,gBATiF;EAUjF,kBALgB;AHyGlB;;AEnGA;ECJE,kCFXY;EEYZ,eDG2C;ECF3C,gBATiF;EAUjF,kBALgB;AHgHlB;;AE1EA;ECpCE,kCFXY;EEYZ,eDmC2C;EClC3C,gBAhBiC;EAiBjC,kBALgB;AHuHlB;;AIpIA;EAC0B,aAAA;EACA,sBAAA;AJuI1B;;AI/HA;EAC0B,uBAAA;EACA,mBAAA;AJkI1B;;AItGA;EAC0B,yBAAA;EACA,mBAAA;AJyG1B;;ADpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACuJF;ADpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACsJF;ADnJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACqJF;ADlJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACoJF;ADjJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACmJF;ADhJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACkJF;AD/IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACiJF;AD9IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACgJF;AD7IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AC+IF;AD5IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AC8IF;AD3IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AC6IF;AD1IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AC4IF;ADzIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AC2IF;ADxIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AC0IF;ADvIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACyIF;ADtIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACwIF;ADrIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACuIF;ADpIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACsIF;AC1PA;;;;;uBAAA;ADFA;EAG0C,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAkQ1C;AAhQE;EAC0C,OAAA;AAkQ5C;AA9P4C;EAAmB,UAAA;AAiQ/D;AAhQ4C;EAAmB,uBAAA;AAmQ/D;AAlQ4C;EAAiB,mBAAA;AAqQ7D;AAnQE;EAC0C,gBAAA;EACA,kBAAA;AAqQ5C;AAnQE;EAE0C,WCZ/B;EDa+B,qBAAA;EACA,cAAA;AAoQ5C;AAlQE;EAE0C,WClB/B;EDmB+B,SAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAmQ5C;AAjQE;EAC0C,gBAAA;EACA,cC5BhC;ED6BgC,YAAA;EACA,WAAA;EACA,mBAAA;AAmQ5C;;AA/PA;EACE;IAC0B,aAAA;IACA,aAAA;EAkQ1B;EAjQE;IAC0B,eAAA;IACA,YAAA;IACA,WAAA;EAmQ5B;EAjQE;IAC0B,eAAA;IACA,aAAA;EAmQ5B;EAjQE;IAC0B,YAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EAmQ5B;EAjQE;IAC0B,YAAA;IACA,WAAA;IACA,eAAA;EAmQ5B;EAhQ4B;IAAiB,oBAAA;EAmQ7C;AACF;AA/PA;EACE;IAC0B,aAAA;EAiQ1B;EAhQE;IAC0B,gBAAA;IACA,YAAA;IACA,WAAA;EAkQ5B;EAhQE;IAC0B,eAAA;IACA,iBAAA;EAkQ5B;EAhQE;IAC0B,YAAA;IACA,eAAA;EAkQ5B;EAhQE;IAC0B,YAAA;IACA,YAAA;IACA,eAAA;EAkQ5B;EA/P4B;IAAiB,oBAAA;EAkQ7C;AACF;AA9PA;EACE;IAC0B,aAAA;EAgQ1B;EA/PE;IAA0B,gBAAA;EAkQ5B;EAjQE;IAC0B,eAAA;IACA,cAAA;EAmQ5B;EAjQE;IAC0B,YAAA;IACA,eAAA;IACA,gBAAA;IACA,qBAAA;EAmQ5B;EAjQE;IAC0B,YAAA;IACA,YAAA;IACA,eAAA;EAmQ5B;EAhQ4B;IAAiB,oBAAA;EAmQ7C;AACF;AA/PA;EACE;IAC0B,aAAA;EAiQ1B;EAhQE;IAA0B,gBAAA;EAmQ5B;EAlQE;IAA0B,YAAA;EAqQ5B;EApQE;IAC0B,eAAA;IACA,cAAA;EAsQ5B;EApQE;IAC0B,eAAA;IACA,aAAA;IACA,YAAA;EAsQ5B;EApQE;IAC0B,YAAA;IACA,gBAAA;IACA,qBAAA;IACA,eAAA;EAsQ5B;EApQE;IAC0B,YAAA;IACA,YAAA;IACA,eAAA;IACA,mBAAA;EAsQ5B;AACF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import 'placeholders/fonts';\n@import 'placeholders/flexboxes';\n@import 'variables/breakpoints';\n@import 'variables';\n\n.rDNA-rXp-container                     {\n                                          @extend %flex-column;\n                                          @extend %flex-jCenter-aCenter;\n                                          height: 250px;\n                                          background: #00AC8E;\n                                          border-radius: 30px;\n                                          margin: 0 10px;\n\n  .rDNA-rXp-box                           {\n                                            flex: 1;\n                                            @extend %flex-column;\n                                            @extend %flex-jEnd-aCenter;\n\n                                            &:nth-of-type(1) { flex: 1.75; }\n                                            &:nth-of-type(2) { justify-content: center; }\n                                            &:last-of-type { padding-bottom: 5px; }\n                                          }\n  .rDNA-rXp-icon                          {\n                                            margin-top: 10px;\n                                            border-radius: 25%;\n                                          }\n  .rDNA-rXp-title                         {\n                                            @extend %font-18px-bold;\n                                            color: $light-text;\n                                            letter-spacing: 1.5px;\n                                            margin: 10px 0;\n                                          }\n  .rDNA-rXp-descrip                       {\n                                            @extend %font-12px-normal;\n                                            color: $light-text;\n                                            margin: 0;\n                                            width: 200px;\n                                            letter-spacing: 1.1px;\n                                            line-height: 1.1;\n                                            text-align: center;\n                                          }\n  .rDNA-rXP-btn                           {\n                                            background: #fff;\n                                            color: $dark-text;\n                                            height: 55px;\n                                            width: 50px;\n                                            border-radius: 10px;\n                                            @extend %font-16px-bold;\n                                          }\n}\n@media screen and ( max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n  .rDNA-rXp-container     {\n                            height: 175px;\n                            margin: 0 3px;\n    .rDNA-rXp-icon          {\n                              margin-top: 5px;\n                              height: 40px;\n                              width: 40px;\n                            }\n    .rDNA-rXp-title         {\n                              font-size: 14px;\n                              margin: 5px 0;\n                            }\n    .rDNA-rXp-descrip       {\n                              width: 120px;\n                              font-size: 10px;\n                              line-height: 1.3;\n                              letter-spacing: 1px;\n                            }\n    .rDNA-rXP-btn           {\n                              height: 30px;\n                              width: 80px;\n                              font-size: 10px;\n                            }\n    .rDNA-rXp-box           {\n                              &:last-of-type { padding-bottom: 10px; }\n                            }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n  .rDNA-rXp-container     {\n                            height: 210px;\n    .rDNA-rXp-icon          {\n                              margin-top: 10px;\n                              height: 50px;\n                              width: 50px;\n                            }\n    .rDNA-rXp-title         {\n                              font-size: 18px;\n                              margin: 7px 0 2px;\n                            }\n    .rDNA-rXp-descrip       {\n                              width: 135px;\n                              font-size: 12px;\n                            }\n    .rDNA-rXP-btn           {\n                              height: 40px;\n                              width: 100px;\n                              font-size: 14px;\n                            }\n    .rDNA-rXp-box           {\n                              &:last-of-type { padding-bottom: 15px; }\n                            }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-lg-max) {\n  .rDNA-rXp-container     {\n                            height: 325px;\n    .rDNA-rXp-icon          { margin-top: 30px; }\n    .rDNA-rXp-title         {\n                              font-size: 28px;\n                              margin: 10px 0;\n                            }\n    .rDNA-rXp-descrip       {\n                              width: 175px;\n                              font-size: 14px;\n                              line-height: 1.5;\n                              letter-spacing: 1.5px;\n                            }\n    .rDNA-rXP-btn           {\n                              height: 55px;\n                              width: 150px;\n                              font-size: 18px;\n                            }\n    .rDNA-rXp-box           {\n                              &:last-of-type { padding-bottom: 30px; }\n                            }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxxl-min) {\n  .rDNA-rXp-container     {\n                            height: 450px;\n    .rDNA-rXp-icon          { margin-top: 50px; }\n    .rDNA-rXP-btn           { width: 200px; }\n    .rDNA-rXp-title         {\n                              font-size: 32px;\n                              margin: 20px 0;\n                            }\n    .rDNA-rXp-icon          {\n                              margin-top: 5px;\n                              height: 100px;\n                              width: 100px;\n                            }\n    .rDNA-rXp-descrip       {\n                              width: 250px;\n                              line-height: 1.5;\n                              letter-spacing: 1.5px;\n                              font-size: 24px;\n                            }\n    .rDNA-rXP-btn           {\n                              height: 65px;\n                              width: 250px;\n                              font-size: 24px;\n                              margin-bottom: 20px;\n                            }\n  }\n}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
